__turbopack_context__.v({
  "eyebrow": "DevelopmentSupportServicesCardSection-module__qzUWPG__eyebrow",
  "heading": "DevelopmentSupportServicesCardSection-module__qzUWPG__heading",
  "section": "DevelopmentSupportServicesCardSection-module__qzUWPG__section",
  "title": "DevelopmentSupportServicesCardSection-module__qzUWPG__title",
});
